export default [
  {
    path: '*',
    meta: { public: true },
    redirect: { path: '/404' },
  },

  {
    path: '/404',
    meta: { public: true },
    name: 'NotFound',
  },

  {
    path: '/stage/:stageId',
    meta: { public: true },
    component: () => import('@/views/Stage.vue'),
  },

  {
    path: '/vr-player/:playerId',
    meta: { public: true },
    component: () => import('@/views/VRPlayer.vue'),
  },
];
